import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import RolloutWizard from '../components/RolloutWizard';
import ArtifactsPanel from '../components/ArtifactsPanel';
import AuditLog from '../components/AuditLog';
import DeviceTokens from '../components/DeviceTokens';
import DeviceRegistrations from '../components/DeviceRegistrations';
import HealthDashboard from '../components/HealthDashboard';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`fleet-tabpanel-${index}`}
      aria-labelledby={`fleet-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `fleet-tab-${index}`,
    'aria-controls': `fleet-tabpanel-${index}`,
  };
}

function getUserRole() {
  try {
    const authData = localStorage.getItem('auth');
    return authData ? JSON.parse(authData).data?.role : null;
  } catch {
    return null;
  }
}

const ALL_FLEET_TABS = [
  { label: 'Health', component: HealthDashboard },
  { label: 'Device Registrations', component: DeviceRegistrations },
  { label: 'Device Tokens', component: DeviceTokens },
  { label: 'Rollouts', component: RolloutWizard },
  { label: 'Artifacts', component: ArtifactsPanel },
  { label: 'Audit', component: AuditLog },
];

export default function AdminLayout() {
  const [value, setValue] = React.useState(0);
  const isAdmin = getUserRole() === 'admin';

  // Non-admin roles (e.g. ict) only get the read-only Health view
  const fleetTabs = isAdmin ? ALL_FLEET_TABS : ALL_FLEET_TABS.slice(0, 1);

  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', pb: 4 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="fleet management tabs">
          {fleetTabs.map((tab, index) => (
            <Tab key={tab.label} label={tab.label} {...a11yProps(index)} />
          ))}
        </Tabs>
      </Box>
      {fleetTabs.map((tab, index) => {
        const TabComponent = tab.component;
        return (
          <TabPanel key={tab.label} value={value} index={index}>
            <TabComponent />
          </TabPanel>
        );
      })}
    </Box>
  );
}
